import React, {Fragment, useRef} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {IconAlertTriangle} from "@tabler/icons-react";
import MegaphoneIcon from "../icons/MegaphoneIcon";

interface Props {
    children: React.ReactNode,
    open?: boolean
    //setOpen: React.Dispatch<React.SetStateAction<boolean>>
    //setConfirmed: React.Dispatch<React.SetStateAction<boolean>>
    cancelLabel?: string,
    confirmLabel?: string,
    onCancel: () => void,
    onConfirm?: () => void,
    zIndex?: string,
}

export const ConfirmModal: React.FC<Props> = ({children, open = true, cancelLabel = 'Annulla', onCancel, confirmLabel = 'Conferma', onConfirm, zIndex = 'z-10'}) => {
    //const [open, setOpen] = useState(true)

    const cancelButtonRef = useRef(null)

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className={`relative ${zIndex}`} initialFocus={cancelButtonRef} onClose={onCancel}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                {children}
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    {onConfirm && <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 p-1.5 sm:p-2 md:py-2 md:px-4 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                            event.preventDefault();
                                            event.stopPropagation();

                                            onConfirm();
                                        }}
                                    >
                                        {confirmLabel}
                                    </button>}
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white p-1.5 sm:p-2 md:py-2 md:px-4 text-base font-medium  shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                            event.preventDefault();
                                            event.stopPropagation();

                                            onCancel();
                                        }}
                                        ref={cancelButtonRef}
                                    >
                                        {cancelLabel}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export const ConfirmDelete: React.FC<Pick<Props, 'onCancel' | 'onConfirm' | 'open'>> = (props) => {
    return <ConfirmModal {...{...props, confirmLabel: 'Cancella'}}>
        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <IconAlertTriangle className="h-6 w-6 text-red-600" aria-hidden="true"/>
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6">
                        Cancellazione elemento
                    </Dialog.Title>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            Sei certo di voler cancellare l'elemento selezionato?<br/>I dati saranno rimossi definitivamente.
                            Questa azione non pu&ograve; essere annullata.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </ConfirmModal>
}
export const ConfirmCancel: React.FC<Pick<Props, 'onCancel' | 'onConfirm' | 'open'>> = (props) => {
    return <ConfirmModal {...{...props, confirmLabel: 'Annulla modifiche', cancelLabel: 'Riprendi edit'}} >
        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <MegaphoneIcon className="h-6 w-6 text-yellow-600" aria-hidden="true"/>
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6">
                        Annulla modifiche
                    </Dialog.Title>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            Sei certo di voler annullare le modifiche apportate all'elemento?
                            Questa azione non potr&agrave; essere annullata.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </ConfirmModal>
}

interface InfoModalProps {
    children: React.ReactNode,
    open?: boolean
    onCancel: () => void,
    zIndex?: string,
}

export const InfoModal: React.FC<InfoModalProps> = (props) => {
    return <ConfirmModal {...{...props, cancelLabel: 'Ok'}} >
        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <MegaphoneIcon className="h-6 w-6 text-yellow-600" aria-hidden="true"/>
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6">
                        Avvertenza
                    </Dialog.Title>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            {props.children}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </ConfirmModal>
}
export default ConfirmModal;